import { createContext, useContext, useState } from 'react';

const DiaporamaGlobalContext = createContext();

export const DiaporamaGlobalProvider = ({ children }) => {
  const [isRunning, setIsRunning] = useState(false);
  const [index, setIndex] = useState(0);
  const [displayCount, setDisplayCount] = useState(0);

  return (
    <DiaporamaGlobalContext.Provider value={{ isRunning, setIsRunning, index, setIndex,displayCount, setDisplayCount }}>
      {children}
    </DiaporamaGlobalContext.Provider>
  );
};

export const useDiaporamaGlobal = () => useContext(DiaporamaGlobalContext);
